export const navigations = [
	{ name: 'Dashboard', path: '/dashboard/default', icon: 'dashboard' },
	{ name: 'Inventory Management', path: '/dashboard/inventory', icon: 'store' },
	{ label: 'Sections', type: 'label' },

	{
		name: 'Agents',
		icon: 'people',
		children: [
			{ name: 'Agents List', iconText: 'SI', path: '/dashboard/customerlist' },
			// { name: 'View Customer', iconText: 'SU', path: '/session/signup' },
			{ name: 'Agents Markup', iconText: 'FP', path: '/dashboard/markupList' },
			{ name: 'Agents Fund', iconText: 'FP', path: '/dashboard/addcustomer' },
			{
				name: 'Agents Transaction',
				iconText: 'FP',
				path: '/dashboard/addcustomer',
			},
		],
	},
	{
		name: 'Flight',
		icon: 'shopping_cart',
		children: [
			{ name: 'Flight Search', iconText: 'SI', path: '/dashboard/flightlist' },
			{
				name: 'Flight Booking',
				iconText: 'SI',
				path: '/dashboard/productlist',
			},
			// { name: 'View Product', iconText: 'SU', path: '/session/signup' },
			// { name: 'Add Product', iconText: 'FP', path: '/dashboard/newproduct' }
		],
	},
	// {
	// 	name: 'Order',
	// 	icon: 'folder',
	// 	children: [
	// 		{ name: 'Order List', iconText: 'SI', path: '/dashboard/orderlist' },
	// 		{ name: 'View Order', iconText: 'SU', path: '/session/signup' }
	// 	]
	// },
	// {
	// 	name: 'Category',
	// 	icon: 'category',
	// 	children: [
	// 		{ name: 'Category List', iconText: 'SI', path: '/dashboard/categorylist' },
	// 		// { name: 'View Category', iconText: 'SU', path: '/session/signup' },
	// 		{ name: 'Add Category', iconText: 'SU', path: '/dashboard/addcategory' }
	// 	]
	// },
	{
		name: 'Banner',
		icon: 'imagesmode',
		children: [
			{ name: 'Banner List', iconText: 'SI', path: '/dashboard/bannerlist' },
			{ name: 'Add Banner', iconText: 'SU', path: '/dashboard/addbanner' },
		],
	},
	{
		name: 'Popular Destination',
		icon: 'imagesmode',
		children: [
			{
				name: 'Popular Destination List',
				iconText: 'SI',
				path: '/dashboard/pslist',
			},
			{
				name: 'Add Popular Destination',
				iconText: 'SU',
				path: '/dashboard/addps',
			},
		],
	},
	{
		name: 'My Finance',
		icon: 'stacked_bar_chart',
		children: [
			{ name: 'Transactions', iconText: 'SI', path: '/dashboard/translist' },
		],
	},
	// {
	// 	name: 'FAQ',
	// 	icon: 'quiz',
	// 	children: [
	// 		{ name: 'FAQ List', iconText: 'SI', path: '/dashboard/faqlist' },
	// 		{ name: 'Add FAQ', iconText: 'SU', path: '/dashboard/addfaq' }
	// 	]
	// },
	// {
	// 	name: 'Website Setting',
	// 	icon: 'settings',
	// 	children: [
	// 		{ name: 'Category List', iconText: 'SI', path: '/session/signin' },
	// 		// { name: 'View Category', iconText: 'SU', path: '/session/signup' },
	// 		{ name: 'Add Category', iconText: 'SU', path: '/session/signup' }
	// 	]
	// },
	// {
	// 	name: 'Coupon',
	// 	icon: 'redeem',
	// 	children: [
	// 		{ name: 'Coupon List', iconText: 'SI', path: 'dashboard/couponlist' },
	// 		{ name: 'Add Coupon', iconText: 'SU', path: '/dashboard/addcoupon' }
	// 	]
	// },
	{ label: 'PAGES', type: 'label' },
	{ name: 'Privacy Policy', path: '/dashboard/privacy', icon: 'shield_locked' },
	{
		name: 'Term & Condition',
		path: '/dashboard/termcondition',
		icon: 'shield_locked',
	},
	{ name: 'About US', path: '/dashboard/aboutus', icon: 'view_compact_alt' },
];
